<!--常见问题-->
<template>
  <div class="content_width_box">
      <div class="content_title">
        <div class="title_left_h2">{{ $t('investor.faq.title') }}</div>
      </div>
      <div class="content_list_layout">
          <div class="question_layout" v-for="(item, index) in $t('investor.faq.questions')" :key="index">
            <div class="question_list_box" @click="toggleAnswer(index)">
              <div class="question_q">
                <i class="iconfont icon-website-wenda"></i>
                <div class="question_title">{{ item.q }}</div>
              </div>
              <i :class="answers[index] ? 'iconfont icon-website-xiangshang' : 'iconfont icon-website-jiahao'"></i>
            </div>
            
            <Collapse>
              <div class="answer_box" v-show="answers[index]">
                <div v-html="formatAnswer(item.a)"></div>
              </div>
            </Collapse>
          </div>
        </div>

    </div>
</template>
<script>
import Collapse from '../../utils/expansion.js'
export default {
    name: 'investorQuestions',
    components:{Collapse},
    created(){
        
    },
    data () {
      return {
        answers: {
          0: false,
          1: false,
          2: false,
          3: false,
          4: false,
          5: false
        }
      }
    },
    computed:{
      
    },
    methods:{
      toggleAnswer(index) {
        this.$set(this.answers, index, !this.answers[index])
      },
      formatAnswer(text) {
        // 将换行符转换为 HTML 换行
        return text.replace(/\n/g, '<br>')
      }
    }
}


</script>
